import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetPeepEngagementStats as GetPeepEngagementStatsQuery,
    GetPeepEngagementStats_peep as Peep,
    GetPeepEngagementStatsVariables,
} from 'nutshell-graphql-types';

import GET_PEEP_ENGAGEMENT_STATS from '../queries/get-peep-engagement-stats.graphql';

export const useGetPeepEngagementStats = (
    peepId: string,
    skip: boolean = false
): {
    peep: Peep | null | undefined;
    isLoading: boolean;
    isFirstLoad: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch, networkStatus} = useQuery<
        GetPeepEngagementStatsQuery,
        GetPeepEngagementStatsVariables
    >(GET_PEEP_ENGAGEMENT_STATS, {
        variables: {
            id: peepId,
        },
        fetchPolicy: 'cache-and-network',
        skip,
    });

    return {
        peep: data?.peep,
        isLoading: loading,
        isFirstLoad: isFirstLoad(networkStatus),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
